/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FlashlightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Flashlight',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m27.306 18.66 5.973-5.974a1 1 0 0 0 0-1.414l-8.524-8.525a1 1 0 0 0-1.414 0L17.367 8.72a1 1 0 0 0-.286.593l-.468 4.078L2.746 27.257a1 1 0 0 0 0 1.414l4.61 4.61a1 1 0 0 0 1.414 0l13.866-13.867 4.077-.468a1 1 0 0 0 .593-.286Zm-10.352.412a2.75 2.75 0 1 1 3.889 0 2.75 2.75 0 0 1-3.889 0Z"
    />
  </svg>`;
};
